import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

export const initialState = {
	sort: 'CREATED_DATE,desc',
	quickFilter: null,
	clients: [],
};

const reducerMap = {
	[types.CHANGE_QUICK_FILTER]: (state, { payload }) => {
		return {
			...state,
			quickFilter: payload.type,
		};
	},
	[types.RESET]: () => initialState,
	[types.SET_UNLOCKED_CLIENTS]: (state, { payload }) => {
		const { unlockedClients } = payload;
		return {
			...state,
			clients: unlockedClients,
		};
	},
	[types.APPEND_UNLOCKED_CLIENTS]: (state, { payload }) => {
		const { unlockedClients } = payload;

		return {
			...initialState,
			clients: [...state.clients, ...unlockedClients],
		};
	},
};

export default handleActions(reducerMap, initialState);
